<template>
    <div class="mail-frame" v-if="mail">
        <div
            class="lm-border mail-header"
        >
            <div class="mail-addr">
                <div class="label primary--text" :style="labelcolor">Von:</div>
                <div class="data mail-receiver" v-if="from"> {{ from }}</div>
            </div>
            <div class="mail-addr">
                <div class="label primary--text" :style="labelcolor">An:</div>
                <div class="data mail-receiver" v-for="(adress, index) in mail.to" :key="index"> {{ adress.email }};</div>
            </div>
            <div class="mail-addr">
                <div class="label primary--text" :style="labelcolor">Cc:</div>
                <div class="data mail-receiver" v-for="(adress, index) in mail.cc" :key="index"> {{ adress.email }};</div>
            </div>
            <div class="mail-addr">
                <div class="label primary--text" :style="labelcolor">Betreff:</div>
                <div class="mail-subject">{{ mail.subject }}</div>
            </div>
        </div>

        <div class="mail-attachment-list" v-if="mail.attachments && mail.attachments.length > 0">
            <div v-for="(attachment, index) in mail.attachments" :key="index" class="mail-attachment" style="display: flex">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                            style  = "display: flex; width: 100%"
                        >
                            <p-dms-icon
                                :icon="icon(attachment)" style="margin-top: 2px; padding-right: 4px;" />
                            <div style=" overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: calc(100% - 25px)">{{ attachment.name }}</div>
                        </div>
                    </template>

                    <div style="display: flex">
                        <p-dms-icon
                            :icon="icon(attachment)"
                            style="margin-top: 2px; padding-right: 4px;"
                        />
                        <div>
                            {{ attachment.name }}
                        </div>
                    </div>
                </v-tooltip>
            </div>
        </div>

        <div class  = "lm-border mail-body">
            <div v-html="body">
            </div>
        </div>
    </div>
</template>

<script>

import PDmsIcon from "@/modules/dms/viewer/private/PDmsIcon.vue";

export default {
    name: "PDmsMailViewer",

    components: {
        PDmsIcon
    },

    props: {
        mail: {
            required: false,
            type    : Object,
            default : function () {
                return {
                    replyTo: [],
                };
            }
        },

        popup: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        height: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
    }),

    mounted() {
        if (!this.popup) {
            return;
        }

        const css_text = `
body {
    font-family: "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    padding: 8px
}

.lm-border {
  padding: 8px;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px!important;
}

.mail-frame {
    display: flex;
    flex-flow: column;
    height: 100%;
}

.mail-header {
    flex: 0 1 auto;
}

.mail-body {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    overflow-y: auto;
    margin-top: 4px;
    flex: 1 1 auto;
    padding: 12px;
}

.mail-body p {
    margin: 0
}

.mail-receiver,
.mail-subject {
    max-width: calc(100% - 80px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 2px!important;
    font-size: 15px;
}

.mail-addr {
    display: flex;
    margin-top: 5px;
    height: 22px;
}

.mail-addr .label {
    width: 60px;
    min-width: 52px;
    display: inline-block;
    padding-left: 5px;
    padding-top: 2px;
    height: 20pt;
    float: left;
    margin-right: 5px;
    font-weight: 500;
    font-size: 15px;
}

.mail-attachment-list {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    overflow-y: scroll;
    margin-top: 4px;
    min-height: 30px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 4px;
    width: calc(100% + 6px);
}

.mail-attachment {
    flex: 0 1 auto;
    padding: 4px;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 4px!important;
    width: calc(25% - 3px);
    max-width: calc(25% - 3px);
    height: 20px;
    padding-left: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 0;
}
`;


        const css = document.createElement('style');
        css.type='text/css';
        css.appendChild(
            document.createTextNode( css_text )
        );

       this.$el.appendChild(css);
    },

    computed: {
        labelcolor () {
            return "color: " + this.primary;
        },

        bodyheight () {
            if (!this.height) {
                return null;
            }

            return "height: " + this.height + "px;";
        },

        primary () {
            return this.$vuetify.theme.themes.light.primary;
        },

        from () {
            if (this.mail.replyTo) {
                let from = "";
                this.mail.replyTo.forEach ((reply, index) => {
                    from = from + reply.name + ' (' + reply.email + ')'
                    if (index < this.mail.replyTo.length-1) {
                        from = from + "; ";
                    }
                });

                return from;
            }

            if (this.mail.from) {
                return this.mail.from.name + " (" + this.mail.from.email +")";
            }

             return null;
        },

        body () {
            const styleStart = this.mail.body.indexOf ("<style");
            const styleEnd   = this.mail.body.indexOf ("</style>");

            if (styleStart >= 0 && styleEnd >= 0) {
                return this.mail.body.substr(0, styleStart-1) + this.mail.body.substr(styleEnd+8);
            }

            return this.mail.body;
        }
    },

    methods: {
        icon (attachment) {
            if (attachment.contentType === "application/pdf") {
                return "pdf"
            }

            return "file";
        }
    }
}
</script>

<style scoped>

.mail-frame {
    display: flex;
    flex-flow: column;
    height: 100%;
}

.mail-header {
    flex: 0 1 auto;
}

.mail-body {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    overflow-y: scroll;
    margin-top: 4px;
    flex: 1 1 auto;
    padding: 12px;
}

.mail-body p {
    margin: 0
}

.mail-receiver,
.mail-subject {
    max-width: calc(100% - 80px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 2px!important;
    font-size: 15px;
}

.mail-addr {
    display: flex;
    margin-top: 5px;
    height: 22px;
}

.mail-addr .label {
    width: 60px;
    min-width: 52px;
    display: inline-block;
    padding-left: 5px;
    padding-top: 2px;
    height: 20pt;
    float: left;
    margin-right: 5px;
    font-weight: 500;
    font-size: 15px;
}

.mail-attachment-list {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 4px;
    width: calc(100% + 0px);
}

.mail-attachment {
    flex: 0 1 auto;
    padding: 4px;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 4px!important;
    width: calc(25% - 3px);
    max-width: calc(25% - 3px);
    height: 30px;
    padding-left: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 0;
}
</style>